import { useContext } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { addSentryBreadcrumb } from '@atlassian/conversation-assistant-instrumentation/services/sentry';

import type { ViewDeadAirBroker } from './types';
import { ViewDeadAirContext } from './ViewDeadAirContext';

let hasLoggedNullContext = false;

function useViewDeadAirContextInternal(): ViewDeadAirBroker | null {
	const context = useContext(ViewDeadAirContext);
	if (context === null && !hasLoggedNullContext) {
		hasLoggedNullContext = true;
		addSentryBreadcrumb('ViewDeadAirTracker: context is null, tracking disabled');
	}
	return context;
}

/**
 * Returns the ViewDeadAirBroker from context, or null if feature flag is off.
 * Uses a wrapper pattern to avoid conditional hook calls.
 */
export function useViewDeadAirContext(): ViewDeadAirBroker | null {
	const isEnabled = fg('rovo_chat_track_view_dead_air');
	const broker = useViewDeadAirContextInternal();
	return isEnabled ? broker : null;
}
